import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { KTSVG } from '../../../_metronic/helpers'
import { worktypeInitialsForApp, worktypeInitialsForUpdate } from './interfaces/worktypeClass';
import { addAccountWorkTypeAsync, updateAccountWorkTypeAsync } from './worktypeSlice'
import { ShowToast } from '../../../common/Toastr';
import { getValueFromResource } from '../../../common/timeLiveFunction';
import * as yup from 'yup';
import { Formik } from 'formik';

const WorkTypeForm = (props: any) => {
    const { t, oncloseModal } = props;
    const dispatch = useAppDispatch();
    const { selectedRecord, worktypeList } = useAppSelector((state) => state.worktype);
    const [disabledCount, setDisabledCount] = useState(0)
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(worktypeInitialsForApp);
    const defaultFocusRef = useRef<HTMLInputElement>(null);

    useEffect(() => {

        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {

            const tempObj: any = selectedRecord;
            Object.keys(worktypeInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            stateItem.IsDeleted = stateItem.IsDeleted === 'Yes' ? true : false;
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(worktypeInitialsForApp);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        calculatedDisabledValue();
    }, [selectedRecord])



    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: e.target.value })
    }

    const handleSubmit = (values: any) => {
        // const handleSubmit = (e: any) => {
        //e.preventDefault();
        if (Object.keys(selectedRecord).length > 0) {

            dispatch(updateAccountWorkTypeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Work Type Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        else {

            dispatch(addAccountWorkTypeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Work Type Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {

                })
        }
        oncloseModal();
    }
    const calculatedDisabledValue = () => {
        if (worktypeList.length > 0) {
            let index = 0;
            worktypeList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(worktypeList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    SortOrder: yup
                    .string()
                    .label('SortOrder')
                    .trim()
                    .required
                    // (t('Sort order is required')),
                    (getValueFromResource('Sort order is required',dispatch, t)),
                    AccountWorkTypeCode: yup
                        .string()
                        .label
                        // (t('AccountWorkTypeCode'))
                        (getValueFromResource('AccountWorkTypeCode',dispatch, t))
                        .trim()
                        .required
                        // (t('Work Type Code is required')),
                        (getValueFromResource('Work Type Code is required',dispatch, t)),
                    AccountWorkType: yup
                        .string()
                        .label
                        // (t('AccountWorkType'))
                        (getValueFromResource('AccountWorkType',dispatch, t))
                        .trim()
                        .required
                        // (t('Work Type is required')),
                        (getValueFromResource('Work Type is required',dispatch, t)),

                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <div className="modal drawer-overlay" style={{ display: 'block' }}>
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                        <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? 
                                        // t('Update') 
                                        getValueFromResource('Update ',dispatch, t)
                                        // : t('Add')} 
                                        : getValueFromResource('Add ',dispatch, t)}
                                        {/* {t('Work Type')}  */}
                                        {getValueFromResource('Work Type',dispatch, t)}
                                        </h5>
                                        <div
                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                            //data-bs-dismiss="modal"
                                            onClick={oncloseModal}
                                        >
                                            <KTSVG
                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                className="svg-icon svg-icon-1x"
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-body">
                                        {/* <div className="mb-3">
                                                                <label className="fs-7 fs-7 fw-normal">{t('Location')}</label>
                                                                <input type="text" className="form-control fs-7 fw-normal" id='AccountLocation' value={values.AccountLocation} name='AccountLocation'
                                                                    onChange={handleChange('AccountLocation')}
                                                                    onBlur={() => setFieldTouched('AccountLocation')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('AccountLocation', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                                                                {touched.AccountLocation && errors.AccountLocation &&
                                                                    <p className='errorMsg'>{errors.AccountLocation as string}</p>
                                                                }
                                                            </div> */}
                                        <div className="mb-0">
                                            <label className="fs-7 fs-7 fw-normal mt-2">
                                                {/* {t('Sort Order')} */}
                                                {getValueFromResource('Sort Order',dispatch, t)}
                                                </label>
                                            <input
                                                ref={defaultFocusRef}
                                                type="Number"
                                                className="form-control fs-7 fw-normal mt-2"
                                                value={values.SortOrder}
                                                id='SortOrder'
                                                name='SortOrder'
                                                onChange={handleChange('SortOrder')}
                                            // onBlur={() => setFieldTouched('SortOrder')}

                                            // value={currentFieldsData.SortOrder}
                                            // onChange={handleTextChange}
                                            />
                                        </div>
                                        <div style={{ paddingRight: 5 }}>
                                            {touched.SortOrder && errors.SortOrder &&
                                                <p className='errorMsg'>{errors.SortOrder as string}</p>
                                            }
                                        </div>

                                        <div className="mb-0 mt-2">
                                            <label className="fs-7 fs-7 fw-normal mt-2">
                                                {/* {t('Work Type Code')} */}
                                                {getValueFromResource('Work Type Code',dispatch, t)}
                                                </label>
                                            <input
                                                // ref={defaultFocusRef}
                                                type="text"
                                                className="form-control fs-7 fw-normal  mt-2"
                                                value={values.AccountWorkTypeCode}
                                                id='AccountWorkTypeCode'
                                                name='AccountWorkTypeCode'
                                                onChange={handleChange('AccountWorkTypeCode')}
                                            // onBlur={() => setFieldTouched('AccountWorkTypeCode')}
                                            // value={currentFieldsData.AccountWorkTypeCode}
                                            // onChange={handleTextChange}
                                            />
                                        </div>
                                        <div style={{ paddingRight: 5 }}>
                                            {touched.AccountWorkTypeCode && errors.AccountWorkTypeCode &&
                                                <p className='errorMsg'>{errors.AccountWorkTypeCode as string}</p>
                                            }
                                        </div>
                                        <div className="mb-0 mt-2">
                                            <label className="fs-7 fs-7 fw-normal  mt-2">
                                                {/* {t('Work Type')} */}
                                                {getValueFromResource('Work Type',dispatch, t)}
                                                </label>
                                            <input
                                                type="text"
                                                className="form-control fs-7 fw-normal mt-2"
                                                value={values.AccountWorkType}
                                                id='AccountWorkType'
                                                name='AccountWorkType'
                                                onChange={handleChange('AccountWorkType')}
                                                // onBlur={() => setFieldTouched('AccountWorkType')}
                                                // value={currentFieldsData.AccountWorkType}
                                                // onChange={handleTextChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        setFieldTouched('AccountWorkType', true);
                                                        handleSubmit();
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div style={{ paddingRight: 5 }}>
                                            {touched.AccountWorkType && errors.AccountWorkType &&
                                                <p className='errorMsg'>{errors.AccountWorkType as string}</p>
                                            }
                                        </div>
                                        {Object.keys(selectedRecord).length > 0 ? (
                                            disabledCount !== 1 ? <div className="mb-3" >
                                                <label className="fs-7 fw-normal mt-2">
                                                    {/* {t('Disabled')} */}
                                                    {getValueFromResource('Disabled',dispatch, t)}
                                                    </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                        onChange={handleChange('IsDisabled')}
                                                    />
                                                </div>
                                            </div> : worktypeList.find(x => x.AccountWorkTypeId === values.AccountWorkTypeId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                <label className="fs-7 fw-normal mt-2">
                                                    {/* {t('Disabled')} */}
                                                    {getValueFromResource('Disabled',dispatch, t)}
                                                    </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                        onChange={handleChange('IsDisabled')}
                                                    />
                                                </div>
                                            </div>)
                                        ) : null}
                                    </div>
                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                            onClick={oncloseModal}
                                        >
                                            {/* {t('Cancel')} */}
                                            {getValueFromResource('Cancel',dispatch, t)}
                                        </button>
                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                            //onClick={handleSubmit}
                                            onClick={() => handleSubmit()} disabled={!isValid}
                                        >
                                            {/* {t('Save')} */}
                                            {getValueFromResource('Save',dispatch, t)}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
        </>
    )
}

export default WorkTypeForm;


// import React, { useEffect, useRef, useState } from 'react'
// import { useAppDispatch, useAppSelector } from '../../../app/hooks';
// import { KTSVG } from '../../../_metronic/helpers'
// import { worktypeInitialsForApp, worktypeInitialsForUpdate } from './interfaces/worktypeClass';
// import { addAccountWorkTypeAsync, updateAccountWorkTypeAsync } from './worktypeSlice'
// import { ShowToast } from '../../../common/Toastr';

// const WorkTypeForm = (props: any) => {
//     const { t, oncloseModal } = props;
//     const dispatch = useAppDispatch();
//     const { selectedRecord } = useAppSelector((state) => state.worktype);

//     const [currentFieldsData, setCurrentFieldsData] = useState<any>(worktypeInitialsForApp);
//     const defaultFocusRef = useRef<HTMLInputElement>(null);

//     useEffect(() => {

//         let stateItem: any = {}
//         if (Object.keys(selectedRecord).length > 0) {

//             const tempObj: any = selectedRecord;
//             Object.keys(worktypeInitialsForUpdate).map((item) => {
//                 return stateItem[item] = tempObj[item];
//             })
//             console.log('stateItem.SortOrder:',stateItem.SortOrder);
//             stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
//             setCurrentFieldsData(stateItem);
//         }
//         else {
//             setCurrentFieldsData(worktypeInitialsForApp);
//         }
//         if (defaultFocusRef.current) {
//             defaultFocusRef.current.focus();
//         }
//     }, [selectedRecord])



//     const handleTextChange = (e: any) => {
//         setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: e.target.value })
//     }

//     const handleSubmit = (e: any) => {
//         e.preventDefault();
//         if (Object.keys(selectedRecord).length > 0) {

//             dispatch(updateAccountWorkTypeAsync(currentFieldsData))
//                 .unwrap()
//                 .then((originalPromiseResult) => {
//                     originalPromiseResult.StatusCode === "200" ?
//                         ShowToast("Work Type Update Successfully", 'Success', "success", "toast-top-right") :
//                         ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
//                 })
//                 .catch((rejectedValueOrSerializedError) => {
//                 })
//         }
//         else {

//             dispatch(addAccountWorkTypeAsync(currentFieldsData))
//                 .unwrap()
//                 .then((originalPromiseResult) => {
//                     originalPromiseResult.StatusCode === "201" ?
//                         ShowToast("Work Type Added Successfully", 'Success', "success", "toast-top-right") :
//                         ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
//                 })
//                 .catch((rejectedValueOrSerializedError) => {

//                 })
//         }
//         oncloseModal();
//     }

//     return (
//         <div className="modal" style={{ display: 'block' }}>
//             <div className="modal-dialog">
//                 <div className="modal-content">
//                     <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
//                         <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? t('Update') : t('Add')} {t('Work Type')} </h5>
//                         <div
//                             className="btn btn-icon btn-sm btn-active-secondary ms-2 "
//                             //data-bs-dismiss="modal"
//                             onClick={oncloseModal}
//                         >
//                             <KTSVG
//                                 path="/media/icons/duotune/arrows/arr061.svg"
//                                 className="svg-icon svg-icon-1x"
//                             />
//                         </div>
//                     </div>
//                     <div className="modal-body">
//                         <div className="mb-3">
//                             <label className="fs-7 fs-7 fw-normal">{t('Sort Order')}</label>
//                             <input
//                                 type="number"
//                                 className="form-control fs-7 fw-normal"
//                                 id='SortOrder'
//                                 value={currentFieldsData.SortOrder}
//                                 onChange={handleTextChange}
//                             />
//                         </div>
//                         <div className="mb-3">
//                             <label className="fs-7 fs-7 fw-normal">{t('Work Type Code')}</label>
//                             <input
//                                 ref={defaultFocusRef}
//                                 type="text"
//                                 className="form-control fs-7 fw-normal"
//                                 id='AccountWorkTypeCode'
//                                 value={currentFieldsData.AccountWorkTypeCode}
//                                 onChange={handleTextChange}
//                             />
//                         </div>
//                         <div className="mb-3">
//                             <label className="fs-7 fs-7 fw-normal">{t('Work Type')}</label>
//                             <input
//                                 type="text"
//                                 className="form-control fs-7 fw-normal"
//                                 id='AccountWorkType'
//                                 value={currentFieldsData.AccountWorkType}
//                                 onChange={handleTextChange}
//                             />
//                         </div>
//                         {Object.keys(selectedRecord).length > 0 ? (
//                             <div className="mb-3" >
//                                 <label className="fs-7 fw-normal">{t('Disabled')}</label>
//                                 <div className="form-check form-switch form-check-custom form-check-solid me-10">
//                                     <input className="form-check-input h-20px w-30px" type="checkbox" checked={currentFieldsData.IsDisabled} id="IsDisabled"
//                                         onChange={handleTextChange}
//                                     />
//                                 </div>
//                             </div>
//                         ) : null}
//                     </div>
//                     <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
//                         <button
//                             type="button"
//                             className="btn btn-secondary btn-bs-btn-font-weight btn-sm p-2 fs-7"
//                             onClick={oncloseModal}
//                         >
//                             {t('Cancel')}
//                         </button>
//                         <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm p-2 fs-7" onClick={handleSubmit}>
//                             {Object.keys(selectedRecord).length > 0 ? t('Update') : t('Add')}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default WorkTypeForm;